// Профиль: имя команды и форма (экраны Team Name и Kit Select, docs/spec/03).

export interface KitDto {
  id: string;
  name: string;
  /** цвет футболки (и вратаря на воротах) */
  color: string;
  /** цвет номера и окантовки */
  accent: string;
  /** из магазина — только для купивших */
  premium?: boolean;
}

export const KITS: readonly KitDto[] = [
  { id: 'red', name: 'Красная', color: '#e53935', accent: '#ffffff' },
  { id: 'blue', name: 'Синяя', color: '#1e63d6', accent: '#ffffff' },
  { id: 'green', name: 'Зелёная', color: '#2e9e4f', accent: '#ffffff' },
  { id: 'yellow', name: 'Жёлтая', color: '#ffd23f', accent: '#1d1600' },
  { id: 'orange', name: 'Оранжевая', color: '#ff8f1f', accent: '#1d1100' },
  { id: 'purple', name: 'Фиолетовая', color: '#7e4ed8', accent: '#ffffff' },
  { id: 'white', name: 'Белая', color: '#f2f4f3', accent: '#14301f' },
  { id: 'black', name: 'Чёрная', color: '#20232a', accent: '#ffd23f' },
  // Премиальные — из магазина (shop.ts, слот kit); в онбординге не показываются
  { id: 'kit-royal', name: 'Королевская', color: '#4b2a8a', accent: '#ffd23f', premium: true },
  { id: 'kit-carbon', name: 'Карбон', color: '#2b2f36', accent: '#ff5a5f', premium: true },
];

export const DEFAULT_KIT = 'orange';
export const kitById = (id: string | null | undefined): KitDto =>
  KITS.find((k) => k.id === id) ?? KITS.find((k) => k.id === DEFAULT_KIT)!;

export const FREE_KITS = KITS.filter((k) => !k.premium);

/** Форма бота — по имени, чтобы у одного бота она была всегда одной и той же (только обычные). */
export function botKit(name: string): string {
  let h = 0;
  for (const ch of name) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return FREE_KITS[h % FREE_KITS.length]!.id;
}

export const TEAM_NAME_MIN = 3;
export const TEAM_NAME_MAX = 20;
/** Буквы любого алфавита, цифры, пробел, дефис, подчёркивание, апостроф. Без ссылок и @-упоминаний. */
export const TEAM_NAME_PATTERN = /^[\p{L}\p{N}][\p{L}\p{N} _'’-]*$/u;

/** Нормализация имени: пробелы по краям и повторные пробелы убираются. */
export const normalizeTeamName = (raw: string) => raw.normalize('NFC').trim().replace(/\s+/g, ' ');

export function teamNameError(raw: string): string | null {
  const name = normalizeTeamName(raw);
  if (name.length < TEAM_NAME_MIN) return `Не короче ${TEAM_NAME_MIN} символов`;
  if (name.length > TEAM_NAME_MAX) return `Не длиннее ${TEAM_NAME_MAX} символов`;
  if (!TEAM_NAME_PATTERN.test(name)) return 'Только буквы, цифры, пробел и дефис';
  return null;
}

/** PATCH /api/me/profile */
export interface UpdateProfileRequest {
  teamName?: string;
  kit?: string;
}
